export const tournaments = [
  {
    name: 'Kotaro Invitational 2019',
    logo: '/assets/tournament-2.png',
  },
  {
    name: 'Infinity Cup 2020',
    logo: '/assets/tournament-1.png',
  },
];

export const promoNumbers = [
  {
    title: 'attendees',
    number: '70,000+',
  },
  {
    title: 'countries',
    number: '160+',
  },
  {
    title: 'speakers',
    number: '1,200+',
  },
  {
    title: 'journalists',
    number: '2,500+',
  },
  {
    title: "CEO's",
    number: '11,000+',
  },
  {
    title: 'fimale',
    number: '46%',
  },
  {
    title: 'investors',
    number: '1,200+',
  },
];

export const advantages = [
  {
    icon: 'fas fa-rocket',
    title: 'Brand awareness',
    subtitle:
      'We bring over 2,500 journalists from the world’s leading publications to TheFront. They’re part of the reason why the event has a global reach of over three billion. We can also work with you on bespoke content packages that will tell your story on a global scale.',
  },
  {
    icon: 'fas fa-brain',
    title: 'Thought leadership',
    subtitle:
      'Maybe you want to place your company front and centre of an industry issue. Maybe you’ve got a new product to launch. We can set up roundtables and workshops for you to host. You’ll be right in the middle of the action, leading discussions with targeted demographics on the topics that matter most to you.',
  },
  {
    icon: 'far fa-comments',
    title: 'Networking',
    subtitle:
      'We have dedicated stages for every industry. Whether you want to hire tech’s top talent, meet with the policymakers influencing your industry, or exchange notes with your peers and competitors, we have the stage, lounge, and evening event for you.',
  },
  {
    icon: 'fas fa-bullhorn',
    title: 'Lead generation',
    subtitle:
      "70,000 people will be joining us at Web Summit this November. They're deeply embedded in the fabric of their respective industries – the trendsetters dictating how quickly new technologies are adopted.",
  },
];

export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const webinars = [
  {
    title: 'Manage Service Providers',
    description:
      'Add new recurring revenue streams to existing managed WiFi networks.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
  },
  {
    title: 'Value Added Resellers',
    description:
      'Add Social WiFi Marketing to your software bundles and suite of services.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
  },
  {
    title: 'Digital Services Agencies',
    description:
      'Help local business owners generate leads and build customer loyalty.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
  },
  {
    title: 'Internet Service Providers',
    description:
      'Upsell Social WiFi as a Service to business Internet subscribers.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
    },
    authorName: 'Kate Segelson',
  },
  {
    title: 'SaaS Aplications',
    description:
      'A lightweight Social WiFi API solution integrate deep into existing platforms.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson@2x.jpg 2x',
    },
    authorName: 'Alex Johnson',
  },
  {
    title: 'Advertising Network',
    description:
      'Generate affiliate commissions by referring new reseller partners to us.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan@2x.jpg 2x',
    },
    authorName: 'Valeria Kogan',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];

export const gallery = [
  {
    image: {
      src: '/assets/chuck-fresco.jpg',
      srcSet: '/assets/chuck-fresco.jpg 2x',
    },
    title: 'gallery',
    cols: 1,
  },
  {
    image: {
      src: '/assets/jiho.jpg',
      srcSet: '/assets/jiho.jpg 2x',
    },
    title: 'gallery',
    cols: 2,
  },
  {
    image: {
      src: '/assets/trung-nguyen.jpg',
      srcSet: '/assets/trung-nguyen.jpg 2x',
    },
    title: 'gallery',
    cols: 1,
  },
  {
    image: {
      src: '/assets/coco.jpg',
      srcSet: '/assets/coco.jpg 2x',
    },
    title: 'gallery',
    cols: 1,
  },
  {
    image: {
      src: '/assets/cloud-white.jpg',
      srcSet: '/assets/cloud-white.jpg 2x',
    },
    title: 'gallery',
    cols: 1,
  },
];
export const teasers = [
  {
    image: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1@2x.jpg 2x',
    },
    title: 'The New Era of Tech Companies',
    subtitle:
      "Drawing thousands of the world's technology leaders together to learn and do business",
    description:
      'Meh synth Schlitz, tempor duis single-origin coffee ea next level ethnic fingerstache fanny pack nostrud. Photo booth anim 8-bit hella, PBR 3 wolf moon beard Helvetica.',
  },
  {
    image: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery2@2x.jpg 2x',
    },
    title: 'We have top executive & start up here',
    subtitle:
      "Drawing thousands of the world's technology leaders together to learn and do business",
    description:
      'Meh synth Schlitz, tempor duis single-origin coffee ea next level ethnic fingerstache fanny pack nostrud. Photo booth anim 8-bit hella, PBR 3 wolf moon beard Helvetica.',
  },
];
